<ngx-audio-player
  *ngIf="msaapPlaylist !== []"
  [playlist]="msaapPlaylist"
  [displayTitle]="msaapDisplayTitle"
  [autoPlay]="true"
  muted="muted"
  [displayPlaylist]="msaapDisplayPlayList"
  [displayVolumeControls]="msaapDisplayVolumeControls"
  [displayRepeatControls]="msaapDisplayRepeatControls"
  [disablePositionSlider]="msaapDisablePositionSlider"
  [displayArtist]="msaapDisplayArtist"
  [displayDuration]="msaapDisplayDuration"
  [expanded]="true"
  [startOffset]="startTime"
  class="audio"
  crossOrigin="anonymus"
>
</ngx-audio-player>
